import { adicionarResposta, atualizarStatusChamado, atribuirResponsavel, getChamadoById, criarChamadoManual, type ChamadoSuporte, type RespostaChamado } from './chamadosHelpers';
import { registrarAuditoria } from './auditoriaHelpers';

export { adicionarResposta, atualizarStatusChamado, atribuirResponsavel, getChamadoById, criarChamadoManual };
export type { ChamadoSuporte, RespostaChamado };

export function criarChamadoManualComAuditoria(
  dados: {
    titulo: string;
    descricao: string;
    tipo: ChamadoSuporte['tipo'];
    prioridade: ChamadoSuporte['prioridade'];
    usuario_tipo: ChamadoSuporte['usuario_tipo'];
    usuario_nome: string;
    usuario_email: string;
    responsavel: string;
    canal_origem?: string;
  },
  usuarioNome: string,
  usuarioRole: string,
): string {
  const novoId = criarChamadoManual(dados);

  registrarAuditoria(
    'criar_chamado',
    'atendimento',
    `Criou chamado manualmente ${novoId} (${dados.titulo})${dados.canal_origem ? ` via ${dados.canal_origem}` : ''}`,
    usuarioNome,
    usuarioRole,
    novoId,
    'chamado',
  );

  return novoId;
}

export function adicionarRespostaComAuditoria(
  chamadoId: string,
  resposta: Parameters<typeof adicionarResposta>[1],
  usuarioNome: string,
  usuarioRole: string,
): boolean {
  const ok = adicionarResposta(chamadoId, resposta);
  if (ok) {
    registrarAuditoria(
      'adicionar_resposta',
      'atendimento',
      `Adicionou resposta ao chamado ${chamadoId}${resposta.interna ? ' (interna)' : ''}`,
      usuarioNome,
      usuarioRole,
      chamadoId,
      'chamado',
    );
  }
  return ok;
}

export function atualizarStatusComAuditoria(
  chamadoId: string,
  novoStatus: ChamadoSuporte['status'],
  usuarioNome: string,
  usuarioRole: string,
): boolean {
  const chamado = getChamadoById(chamadoId);
  if (!chamado) return false;
  const statusAnterior = chamado.status;
  const ok = atualizarStatusChamado(chamadoId, novoStatus);
  if (ok) {
    registrarAuditoria(
      'alterar_status_chamado',
      'atendimento',
      `Alterou status do chamado ${chamadoId} de "${statusAnterior}" para "${novoStatus}"`,
      usuarioNome,
      usuarioRole,
      chamadoId,
      'chamado',
    );
  }
  return ok;
}

export function atribuirResponsavelComAuditoria(
  chamadoId: string,
  responsavel: string,
  usuarioNome: string,
  usuarioRole: string,
): boolean {
  const chamado = getChamadoById(chamadoId);
  if (!chamado) return false;
  const respAnterior = chamado.responsavel || 'Não atribuído';
  const ok = atribuirResponsavel(chamadoId, responsavel);
  if (ok) {
    registrarAuditoria(
      'atribuir_chamado',
      'atendimento',
      `Atribuiu chamado ${chamadoId} para ${responsavel} (anterior: ${respAnterior})`,
      usuarioNome,
      usuarioRole,
      chamadoId,
      'chamado',
    );
  }
  return ok;
}